.o-text-introduction {
  margin-top: 0;
  margin-bottom: 60px;
}
.o-text-introduction > * {
  margin-top: 0;
  margin-bottom: 15px;
  max-width: 41.875rem;
}